import {toDateFromISOFormat} from '@common/utils/date';
import {PERIOD_STATE_TYPE} from '@common/consts/survey';

/**
 * 신청기간 현재상태 가져오기 - 동적으로 변경하기위해 메소드로 작성
 * @param survey
 * @returns {string}
 */
export function getPeriodStateType(survey) {
    const startDate = toDateFromISOFormat(survey.startDate);
    const endDate = toDateFromISOFormat(survey.endDate);

    if (Date.now() > endDate) {
        return PERIOD_STATE_TYPE.ENDED;
    } else if (Date.now() < startDate) {
        return PERIOD_STATE_TYPE.BEFORE_PERIOD;
    } else {
        return PERIOD_STATE_TYPE.ONGOING;
    }
}
